// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AssistantRouteImport } from './routes/assistant'
import { Route as CasesRouteImport } from './routes/cases'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EmailRouteImport } from './routes/email'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as GeoRouteImport } from './routes/geo'
import { Route as GetSoftwareRouteImport } from './routes/get-software'
import { Route as GraphRouteImport } from './routes/graph'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as ImageryRouteImport } from './routes/imagery'
import { Route as InvestigateRouteImport } from './routes/investigate'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MonitorRouteImport } from './routes/monitor'
import { Route as NexusRouteImport } from './routes/nexus'
import { Route as OsintRouteImport } from './routes/osint'
import { Route as PersonRouteImport } from './routes/person'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SourcesRouteImport } from './routes/sources'
import { Route as TeamRouteImport } from './routes/team'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ThreatSimulationRouteImport } from './routes/threat-simulation'
import { Route as ThreatsRouteImport } from './routes/threats'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as WorkspaceRouteImport } from './routes/workspace'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as VaultIndexRouteImport } from './routes/vault.index'
import { Route as VaultScanIdRouteImport } from './routes/vault.$scanId'
import { Route as VaultScanIdIndexRouteImport } from './routes/vault.$scanId.index'
import { Route as VaultScanIdCanvasRouteImport } from './routes/vault.$scanId.canvas'
import { Route as VaultScanIdGraphRouteImport } from './routes/vault.$scanId.graph'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AcceptInviteRoute = AcceptInviteRouteImport.update({
            id: '/accept-invite',path: '/accept-invite',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AssistantRoute = AssistantRouteImport.update({
            id: '/assistant',path: '/assistant',getParentRoute: () => rootRouteImport
          })
const CasesRoute = CasesRouteImport.update({
            id: '/cases',path: '/cases',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const EmailRoute = EmailRouteImport.update({
            id: '/email',path: '/email',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const GeoRoute = GeoRouteImport.update({
            id: '/geo',path: '/geo',getParentRoute: () => rootRouteImport
          })
const GetSoftwareRoute = GetSoftwareRouteImport.update({
            id: '/get-software',path: '/get-software',getParentRoute: () => rootRouteImport
          })
const GraphRoute = GraphRouteImport.update({
            id: '/graph',path: '/graph',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const ImageryRoute = ImageryRouteImport.update({
            id: '/imagery',path: '/imagery',getParentRoute: () => rootRouteImport
          })
const InvestigateRoute = InvestigateRouteImport.update({
            id: '/investigate',path: '/investigate',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MonitorRoute = MonitorRouteImport.update({
            id: '/monitor',path: '/monitor',getParentRoute: () => rootRouteImport
          })
const NexusRoute = NexusRouteImport.update({
            id: '/nexus',path: '/nexus',getParentRoute: () => rootRouteImport
          })
const OsintRoute = OsintRouteImport.update({
            id: '/osint',path: '/osint',getParentRoute: () => rootRouteImport
          })
const PersonRoute = PersonRouteImport.update({
            id: '/person',path: '/person',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const ReportsRoute = ReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => rootRouteImport
          })
const RequestAccessRoute = RequestAccessRouteImport.update({
            id: '/request-access',path: '/request-access',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SourcesRoute = SourcesRouteImport.update({
            id: '/sources',path: '/sources',getParentRoute: () => rootRouteImport
          })
const TeamRoute = TeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ThreatSimulationRoute = ThreatSimulationRouteImport.update({
            id: '/threat-simulation',path: '/threat-simulation',getParentRoute: () => rootRouteImport
          })
const ThreatsRoute = ThreatsRouteImport.update({
            id: '/threats',path: '/threats',getParentRoute: () => rootRouteImport
          })
const TimelineRoute = TimelineRouteImport.update({
            id: '/timeline',path: '/timeline',getParentRoute: () => rootRouteImport
          })
const WorkspaceRoute = WorkspaceRouteImport.update({
            id: '/workspace',path: '/workspace',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const VaultIndexRoute = VaultIndexRouteImport.update({
            id: '/vault/',path: '/vault/',getParentRoute: () => rootRouteImport
          })
const VaultScanIdRoute = VaultScanIdRouteImport.update({
            id: '/vault/$scanId',path: '/vault/$scanId',getParentRoute: () => rootRouteImport
          })
const VaultScanIdIndexRoute = VaultScanIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VaultScanIdRoute
          })
const VaultScanIdCanvasRoute = VaultScanIdCanvasRouteImport.update({
            id: '/canvas',path: '/canvas',getParentRoute: () => VaultScanIdRoute
          })
const VaultScanIdGraphRoute = VaultScanIdGraphRouteImport.update({
            id: '/graph',path: '/graph',getParentRoute: () => VaultScanIdRoute
          })





const VaultScanIdRouteChildren = {
  VaultScanIdCanvasRoute: VaultScanIdCanvasRoute,VaultScanIdGraphRoute: VaultScanIdGraphRoute,VaultScanIdIndexRoute: VaultScanIdIndexRoute
}

const VaultScanIdRouteWithChildren = VaultScanIdRoute._addFileChildren(VaultScanIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AcceptInviteRoute: AcceptInviteRoute,AdminRoute: AdminRoute,AdminLoginRoute: AdminLoginRoute,AssistantRoute: AssistantRoute,CasesRoute: CasesRoute,ContactsRoute: ContactsRoute,DashboardRoute: DashboardRoute,EmailRoute: EmailRoute,ForgotPasswordRoute: ForgotPasswordRoute,GeoRoute: GeoRoute,GetSoftwareRoute: GetSoftwareRoute,GraphRoute: GraphRoute,GuideRoute: GuideRoute,ImageryRoute: ImageryRoute,InvestigateRoute: InvestigateRoute,LoginRoute: LoginRoute,MonitorRoute: MonitorRoute,NexusRoute: NexusRoute,OsintRoute: OsintRoute,PersonRoute: PersonRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundPolicyRoute: RefundPolicyRoute,ReportsRoute: ReportsRoute,RequestAccessRoute: RequestAccessRoute,ResetPasswordRoute: ResetPasswordRoute,SettingsRoute: SettingsRoute,SignupRoute: SignupRoute,SourcesRoute: SourcesRoute,TeamRoute: TeamRoute,TermsRoute: TermsRoute,ThreatSimulationRoute: ThreatSimulationRoute,ThreatsRoute: ThreatsRoute,TimelineRoute: TimelineRoute,WorkspaceRoute: WorkspaceRoute,BlogSlugRoute: BlogSlugRoute,VaultScanIdRoute: VaultScanIdRouteWithChildren,BlogIndexRoute: BlogIndexRoute,VaultIndexRoute: VaultIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)